module.exports = __webpack_public_path__ + "media/images/users/user-11-359b62388e693a44880553106c6a1045.jpg";